import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import {
  PromptBannerCard,
  MintListingPromptPattern,
  mintListingPromptBannerLayout,
  mintListingPromptBodyTextProps,
  mintListingPromptTitleTextProps,
  promptBannerPillButtonStyle,
  useMintListingPromptMinHeight,
} from 'app/components/prompt-banner-card';
import { useNavigation } from 'app/hooks/navigation';
import type { ViewProps } from 'react-native';
import { Pressable } from 'react-native';

function InvitePromptCard({
  title,
  text,
  buttonText,
  /** @deprecated Ignored; banner width is capped by the shared shell (400px max). */
  width: _width,
  ...rest
}: ViewProps & {
  title: string;
  text: string;
  buttonText: string;
  width?: number;
}) {
  const navigation = useNavigation();
  const minHeight = useMintListingPromptMinHeight();

  const goToInvite = () => {
    navigation.navigate('invite', undefined, { pop: true });
  };

  return (
    <Pressable {...rest} onPress={goToInvite}>
      <PromptBannerCard
        {...mintListingPromptBannerLayout}
        backgroundDecoration={<MintListingPromptPattern />}
        style={{ minHeight }}
      >
        <Text {...mintListingPromptTitleTextProps}>{title}</Text>
        <Text {...mintListingPromptBodyTextProps}>{text}</Text>
        <Button onPress={goToInvite} style={promptBannerPillButtonStyle} variant="small-pill">
          <Text color="surface.default" variant="bodyBase">
            {buttonText}
          </Text>
        </Button>
      </PromptBannerCard>
    </Pressable>
  );
}

export { InvitePromptCard };
